import api from '../client';

export const KSGService = {
  getObjects: (params) => api.get('/ksg/objects', { params }),
  getObject: (id) => api.get(`/ksg/objects/${id}`),
  createObject: (data) => api.post('/ksg/objects', data),
  updateObject: (id, data) => api.patch(`/ksg/objects/${id}`, data),
  deleteObject: (id) => api.delete(`/ksg/objects/${id}`),
  getObjectStats: (id) => api.get(`/ksg/objects/${id}/stats`),

  getWorks: (objectId) => api.get(`/ksg/objects/${objectId}/works`),
  createWork: (data) => api.post('/ksg/works', data),
  createWorksBulk: (objectId, works) => api.post(`/ksg/objects/${objectId}/works/bulk`, { works }),
  updateWork: (id, data) => api.patch(`/ksg/works/${id}`, data),
  deleteWork: (id) => api.delete(`/ksg/works/${id}`),

  exportWorksExcel: (objectId) => api.get(`/ksg/objects/${objectId}/works/export`, { responseType: 'blob' }),
  importWorksExcel: (objectId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/ksg/objects/${objectId}/works/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  exportToTasks: (objectId, data) => api.post(`/ksg/objects/${objectId}/export-to-tasks`, data),

  aiChatStart: (data) => api.post('/ksg/ai/chat/start', data),
  aiChatMessage: (data) => api.post('/ksg/ai/chat/message', data, { timeout: 300000 }),
  aiGenerate: (data) => api.post('/ksg/ai/generate', data),
  aiEstimate: (objectId) => api.post('/ksg/ai/estimate', { object_id: objectId }),
  aiRisks: (objectId) => api.post('/ksg/ai/risks', { object_id: objectId }),
  aiOptimize: (objectId) => api.post('/ksg/ai/optimize', { object_id: objectId }),
  aiSuggest: (objectId) => api.post('/ksg/ai/suggest', { object_id: objectId }),

  aiGpzuAnalyze: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/ksg/ai/gpzu/analyze', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 180000,
    });
  },
  aiGpzuFeasibility: (gpzuData, params) => api.post('/ksg/ai/gpzu/feasibility', gpzuData, { params }),

  // Шаблоны блоков
  getTemplateBlocks: (includeInactive) => api.get('/ksg/templates/blocks', { params: { include_inactive: includeInactive } }),
  getTemplateBlockDetail: (id) => api.get(`/ksg/templates/blocks/${id}`),
  createTemplateBlock: (data) => api.post('/ksg/templates/blocks', data),
  updateTemplateBlock: (id, data) => api.patch(`/ksg/templates/blocks/${id}`, data),
  deleteTemplateBlock: (id) => api.delete(`/ksg/templates/blocks/${id}`),
  getTemplatesList: () => api.get('/ksg/templates/list'),

  // Шаблоны задач
  createTemplateTask: (data) => api.post('/ksg/templates/tasks', data),
  updateTemplateTask: (id, data) => api.patch(`/ksg/templates/tasks/${id}`, data),
  deleteTemplateTask: (id) => api.delete(`/ksg/templates/tasks/${id}`),

  // Создание объекта из шаблона
  createObjectFromTemplate: (templateId, objectData) => api.post(`/ksg/objects/from-template?template_id=${templateId}`, objectData),

  // Визард
  wizardGenerate: (data) => api.post('/ksg/wizard/generate', data, { timeout: 60000 }),
  wizardPreview: (data) => api.post('/ksg/wizard/preview', data),

  // Черновики
  getDrafts: (params) => api.get('/ksg/drafts', { params }),
  getDraft: (id) => api.get(`/ksg/drafts/${id}`),
  updateDraft: (id, data) => api.patch(`/ksg/drafts/${id}`, data),
  deleteDraft: (id) => api.delete(`/ksg/drafts/${id}`),
  regenerateDraft: (id) => api.post(`/ksg/drafts/${id}/regenerate`, {}, { timeout: 60000 }),
  getDraftTasks: (id, params) => api.get(`/ksg/drafts/${id}/tasks`, { params }),
  updateDraftTask: (taskId, data) => api.patch(`/ksg/drafts/tasks/${taskId}`, data),
  toggleDraftTask: (taskId) => api.post(`/ksg/drafts/tasks/${taskId}/toggle`),
  deleteDraftTask: (taskId) => api.delete(`/ksg/drafts/tasks/${taskId}`),
  restoreDraftTask: (taskId) => api.post(`/ksg/drafts/tasks/${taskId}/restore`),
  recalculateDraft: (id) => api.post(`/ksg/drafts/${id}/recalculate`),
  recalculateDependencies: (id) => api.post(`/ksg/drafts/${id}/recalculate-dependencies`),
  getDraftGantt: (id) => api.get(`/ksg/drafts/${id}/gantt`),

  // Экспорт в проект
  exportDraftToProject: (draftId, data) => api.post(`/ksg/drafts/${draftId}/export`, data),

  // Сезонность
  getSeasonConfigs: () => api.get('/ksg/season/configs'),
  createSeasonConfig: (data) => api.post('/ksg/season/configs', data),
  updateSeasonConfig: (id, data) => api.patch(`/ksg/season/configs/${id}`, data),
};
